import { AxiosResponse } from 'axios';
import api from './Api'

export const cancelProgramBooking = (programBookingId: string): Promise<AxiosResponse<boolean, any>> => {
    return api.put(`/program/booking/cancel/${programBookingId}`);
}

export const getProgramBookingListWebByStatus = (status: string, responseQuery?: string) => {
    const query = `query GetProgramBookingListWebByStatus($status:String) { getProgramBookingListWebByStatus(status: $status) { ${responseQuery} } }`
    return api.post<IGraphqlResponse<{ getProgramBookingListWebByStatus: Array<IProgramBookingWebResponse> }>>('/graphql', { query, variables: { status: status } })
}

const defalutQuery = 'programTitle programIsPaid qrcodeImgUrl memberName targetDateTime ticketTotalCount ticketCheckResponseList { ticketName }'
export const getProgramBookingTicketCheckWebByProgramBookingId = <T>(programBookingId: number, responseQuery: string = defalutQuery) => {
    const query = `query GetProgramBookingTicketCheckWebByProgramBookingId($programBookingId: ID) { getProgramBookingTicketCheckWebByProgramBookingId(programBookingId: $programBookingId) { ${responseQuery} } }`
    return api.post<IGraphqlResponse<{ getProgramBookingTicketCheckWebByProgramBookingId: T }>>('/graphql', { query, variables: { programBookingId } })
}